export enum FixtureRosterTableColumns {
  Starter = "starter",
}
